import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

const industries = [
{
  name: "Customer Service",
  icon: "🛎️",
  description: "Enhance support with AI-powered chatbots, ticket routing, and query resolution",
  slug: "customer-service"
},
{
  name: "Healthcare",
  icon: "🏥",
  description: "Automate appointment scheduling, patient follow-ups, and medical record summaries",
  slug: "healthcare"
},
{
  name: "Recruitment",
  icon: "👔",
  description: "Streamline candidate screening, interview scheduling, and resume analysis",
  slug: "recruitment"
},
{
  name: "Real Estate",
  icon: "🏠",
  description: "Automate property inquiries, viewing schedules, and client follow-ups",
  slug: "real-estate"
},
{
  name: "Retail",
  icon: "🛍️",
  description: "Optimize inventory management, customer engagement, and personalized recommendations",
  slug: "retail"
},
{
  name: "Education",
  icon: "🎓",
  description: "Transform learning with AI tutoring, administrative automation, and student support",
  slug: "education"
},
{
  name: "Automotive",
  icon: "🚗",
  description: "Improve lead handling, service scheduling, and customer inquiries",
  slug: "automotive"
},
{
  name: "Financial Services",
  icon: "💰",
  description: "Enhance client services, fraud detection, and transaction processing",
  slug: "financial-services"
},
{
  name: "Transportation & Logistics",
  icon: "🚚",
  description: "Optimize routing, tracking, scheduling, and supply chain management",
  slug: "transportation-logistics"
}];


export default function IndustrySection() {
  return (
    <section className="py-16 bg-white" data-id="kw38awt9g" data-path="src/components/home/IndustrySection.tsx">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="ouop2ozog" data-path="src/components/home/IndustrySection.tsx">
        <div className="text-center mb-12" data-id="3ouqz3ku9" data-path="src/components/home/IndustrySection.tsx">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4" data-id="gxusa9zbw" data-path="src/components/home/IndustrySection.tsx">
            AI Automation for Every Industry
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="rl25wwr2d" data-path="src/components/home/IndustrySection.tsx">
            Our AI automation solutions are tailored to meet the specific needs of various industries,
            providing targeted efficiency improvements.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="6y3a2pzdx" data-path="src/components/home/IndustrySection.tsx">
          {industries.map((industry, index) =>
          <Card key={index} className="border border-gray-200 hover:shadow-lg transition-shadow" data-id="m6b0l6t8h" data-path="src/components/home/IndustrySection.tsx">
              <CardContent className="p-6" data-id="3yhwmpfsg" data-path="src/components/home/IndustrySection.tsx">
                <div className="text-4xl mb-4" data-id="cxtqa80v5" data-path="src/components/home/IndustrySection.tsx">{industry.icon}</div>
                <h3 className="text-xl font-medium text-gray-900 mb-3" data-id="qqcihm9jv" data-path="src/components/home/IndustrySection.tsx">{industry.name}</h3>
                <p className="text-gray-600 mb-4" data-id="n161o426v" data-path="src/components/home/IndustrySection.tsx">{industry.description}</p>
              </CardContent>
            </Card>
          )}
        </div>

        <div className="text-center mt-12" data-id="5jmkg273c" data-path="src/components/home/IndustrySection.tsx">
          <Button asChild size="lg" className="bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white" data-id="7wu4wh31f" data-path="src/components/home/IndustrySection.tsx">
            <Link to="/industries" data-id="1on3nore7" data-path="src/components/home/IndustrySection.tsx">View All Industries</Link>
          </Button>
        </div>
      </div>
    </section>);

}